/* Copyright (c) 2019 - 2021. Verimatrix. All Rights Reserved.
   All information in this file is Verimatrix Confidential and Proprietary. */

import React from "react";
import {
  STATE_CANCELLED,
  STATE_DONE,
  STATE_ERROR,
  STATE_EXPIRED,
  STATE_IN_PROGRESS,
  STATE_NO_BUILDS,
  STATE_PENDING_SUPPORT,
  STATE_QUEUE,
  STATE_START,
  STATE_UPLOADED,
  STATE_UPLOAD_FAILED,
} from "../Authenticator/utils";

interface StateIconProps {
  name: string;
  style?: React.CSSProperties;
  color?: string;
}

const icons: any = {
  [STATE_START]: (color: string) => (
    <svg
      width="24px"
      height="24px"
      fill={color || "#4261ed"}
      version="1.1"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z" />
    </svg>
  ),
  [STATE_UPLOADED]: (color: string) => (
    <svg
      width="24px"
      height="24px"
      fill={color || "#4261ed"}
      version="1.1"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zm-8.64 6.25c-.39.39-1.02.39-1.41 0L7.2 14.2c-.39-.39-.39-1.02 0-1.41.39-.39 1.02-.39 1.41 0L10 14.18l4.48-4.48c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41l-5.18 5.18z" />
    </svg>
  ),
  [STATE_UPLOAD_FAILED]: (color: string) => (
    <svg
      width="24px"
      height="24px"
      fill={color || "#f65b02"}
      version="1.1"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M19.35 10.04C18.67 6.59 15.64 4 12 4c-1.48 0-2.85.43-4.01 1.17l1.46 1.46C10.21 6.23 11.08 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3 0 1.13-.64 2.11-1.56 2.62l1.45 1.45C23.16 18.16 24 16.68 24 15c0-2.64-2.05-4.78-4.65-4.96zM3 5.27l2.75 2.74C2.56 8.15 0 10.77 0 14c0 3.31 2.69 6 6 6h11.73l2 2L21 20.73 4.27 4 3 5.27zM7.73 10l8 8H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h1.73z" />
    </svg>
  ),
  [STATE_CANCELLED]: (color: string) => (
    <svg
      width="24px"
      height="24px"
      enableBackground="new 0 0 24 24"
      fill={color || "#4261ed"}
      version="1.1"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none">
        <rect width="24" height="24" />
        <rect width="24" height="24" />
      </g>
      <path d="m20 11.09v-4.7c0-0.83-0.52-1.58-1.3-1.87l-6-2.25c-0.45-0.17-0.95-0.17-1.4 0l-4.52 1.69 12.09 12.09c0.72-1.53 1.13-3.22 1.13-4.96zm0.49 9.4-16.98-16.98c-0.39-0.39-1.02-0.39-1.41 0s-0.39 1.02 0 1.41l1.9 1.91v4.26c0 4.83 3.13 9.37 7.43 10.75 0.37 0.12 0.77 0.12 1.14 0 1.49-0.48 2.84-1.35 3.97-2.47l2.53 2.53c0.39 0.39 1.02 0.39 1.41 0 0.4-0.39 0.4-1.02 0.01-1.41z" />
    </svg>
  ),
  [STATE_QUEUE]: (color: string) => (
    <svg
      width="24px"
      height="24px"
      fill={color || "#4261ed"}
      version="1.1"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M6 4v3.17c0 .53.21 1.04.59 1.42L10 12l-3.42 3.42c-.37.38-.58.89-.58 1.42V20c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2v-3.16c0-.53-.21-1.04-.58-1.41L14 12l3.41-3.4c.38-.38.59-.89.59-1.42V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2z" />
    </svg>
  ),
  [STATE_IN_PROGRESS]: (color: string) => (
    <svg
      width="24px"
      height="24px"
      enableBackground="new 0 0 24 24"
      fill={color || "#4261ed"}
      version="1.1"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none">
        <rect width="24" height="24" />
        <rect width="24" height="24" />
      </g>
      <path d="m11.3 2.26-6 2.25c-0.78 0.3-1.3 1.04-1.3 1.88v4.7c0 4.83 3.13 9.37 7.43 10.75 0.37 0.12 0.77 0.12 1.14 0 4.3-1.38 7.43-5.91 7.43-10.75v-4.7c0-0.83-0.52-1.58-1.3-1.87l-6-2.25c-0.45-0.18-0.95-0.18-1.4-0.01zm0.7 14.74c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm2-3c-0.2 0.2-0.51 0.2-0.71 0l-1.65-1.65c-0.09-0.09-0.15-0.22-0.15-0.35v-2.5c0.01-0.28 0.23-0.5 0.51-0.5s0.5 0.22 0.5 0.5v2.29l1.5 1.5c0.2 0.2 0.2 0.51 0 0.71z" />
    </svg>
  ),
  [STATE_PENDING_SUPPORT]: (color: string) => (
    <svg
      width="24px"
      height="24px"
      enableBackground="new 0 0 24 24"
      fill={color || "#4261ed"}
      version="1.1"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" fill="none" />
      <path d="M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10s10-4.5,10-10S17.5,2,12,2z M16.2,16.2L11,13V7h1.5v5.2l4.5,2.7L16.2,16.2z" />
    </svg>
  ),
  [STATE_ERROR]: (color: string) => (
    <svg
      width="24px"
      height="24px"
      enableBackground="new 0 0 24 24"
      fill={color || "#f65b02"}
      version="1.1"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m19.528 3.5919-6.7357-2.4594c-0.50518-0.18582-1.0665-0.18582-1.5716 0l-6.7357 2.4594c-0.87564 0.32792-1.4594 1.1368-1.4594 2.055v5.1374c0 5.3997 3.6709 10.461 8.6554 11.838 0.2133 0.05464 0.43782 0.05464 0.63989 0 4.9957-1.3773 8.6666-6.4382 8.6666-11.838v-5.1374c0-0.91817-0.58376-1.727-1.4594-2.055zm-4.3783 11.236c-0.43782 0.42629-1.1451 0.42629-1.5829 0.01093l-1.5605-1.5084-1.5605 1.5084c-0.43782 0.4263-1.1451 0.4263-1.5829 0-0.43782-0.4263-0.43782-1.1149 0-1.5412l1.5605-1.5194-1.5605-1.5194c-0.43782-0.42629-0.43782-1.1149 0-1.5412 0.43783-0.42629 1.1451-0.42629 1.5829 0l1.5605 1.5194 1.5605-1.5194c0.43782-0.42629 1.1451-0.42629 1.5829 0 0.43782 0.42629 0.43782 1.1149 0 1.5412l-1.5492 1.5194 1.5492 1.5084c0.43782 0.42629 0.43782 1.1149 0 1.5412z"
        strokeWidth="1.1078"
      />
    </svg>
  ),
  [STATE_DONE]: (color: string) => (
    <svg
      width="24px"
      height="24px"
      fill={color || "#7bbb5e"}
      version="1.1"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M11.19 1.36l-7 3.11C3.47 4.79 3 5.51 3 6.3V11c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V6.3c0-.79-.47-1.51-1.19-1.83l-7-3.11c-.51-.23-1.11-.23-1.62 0zm-1.9 14.93L6.7 13.7c-.39-.39-.39-1.02 0-1.41.39-.39 1.02-.39 1.41 0L10 14.17l5.88-5.88c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41l-6.59 6.59c-.38.39-1.02.39-1.41 0z" />
    </svg>
  ),
  [STATE_EXPIRED]: (color: string) => (
    <svg
      width="24px"
      height="24px"
      enableBackground="new 0 0 24 24"
      fill={color || "#aaaaaa"}
      version="1.1"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none">
        <rect width="24" height="24" />
        <rect width="24" height="24" />
      </g>
      <path d="m16 9c-0.7 0-1.37 0.1-2 0.29v-2.29c0-1.1-0.9-2-2-2h-8c-1.1 0-2 0.9-2 2v10c0 1.1 0.9 2 2 2h5.68c1.12 2.36 3.53 4 6.32 4 3.87 0 7-3.13 7-7s-3.13-7-7-7zm0 12c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z" />
      <path d="m14 4c0.55 0 1-0.45 1-1s-0.45-1-1-1h-2.5l-0.71-0.71c-0.18-0.18-0.44-0.29-0.7-0.29h-4.18c-0.26 0-0.52 0.11-0.7 0.29l-0.71 0.71h-2.5c-0.55 0-1 0.45-1 1s0.45 1 1 1h12z" />
      <path d="m15.75 12c-0.41 0-0.75 0.34-0.75 0.75v3.68c0 0.36 0.19 0.68 0.5 0.86l2.52 1.47c0.33 0.19 0.75 0.09 0.96-0.22 0.23-0.34 0.12-0.81-0.24-1.02l-2.24-1.32v-3.45c0-0.41-0.34-0.75-0.75-0.75z" />
    </svg>
  ),
  [STATE_NO_BUILDS]: (color: string) => (
    <svg
      width="24px"
      height="24px"
      fill={color || "#aaaaaa"}
      version="1.1"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M19 3H4.99c-1.11 0-1.98.89-1.98 2L3 19c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5c0-1.11-.9-2-2-2zm0 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H4.99V5H19v10z" />
    </svg>
  ),
};

export const StateIcon: React.FC<StateIconProps> = ({ name, style, color }) => {
  const icon = icons[name]?.(color) || "";
  return <span style={{ display: "flex", ...style }}>{icon}</span>;
};
